var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReloardform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 13.3333H16.3333V17.5M8.83333 6.66667H4.66667V2.5M16.6813 7.50284C16.2141 6.34638 15.4318 5.3442 14.4233 4.61019C13.4149 3.87618 12.221 3.4396 10.9769 3.35042C9.73281 3.26125 8.48839 3.52284 7.38558 4.10551C6.28277 4.68819 5.36569 5.56878 4.73828 6.64677M4.31836 12.4976C4.7856 13.654 5.56788 14.6562 6.57631 15.3902C7.58474 16.1242 8.7799 16.5602 10.024 16.6494C11.2681 16.7386 12.5115 16.477 13.6143 15.8944C14.7171 15.3117 15.6335 14.4313 16.2609 13.3533",
    stroke: "#001A54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloardform);
export default __webpack_public_path__ + "static/media/reloardform.12d996eb6be0c3f67bbabdaac79523b8.svg";
export { ForwardRef as ReactComponent };